import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.metrics.gap};

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    flex-direction: column;
    max-height: initial;
  }
`;
